import { Outlet } from "react-router"
import { Header } from "@/client/components/header/header"
import { TabBar } from "@/client/components/tab-bar"
import styles from "./client-layout.module.css"

export function ClientLayout() {
  return (
    <div className={styles.container}>
      <Header />
      <main className={styles.main}>
        <Outlet />
      </main>
      <TabBar />
    </div>
  )
}